import fetchAPI from 'shared/fetchAPI'
import APP_ISO_CONF from 'shared/appIsoConf'
import Cookies from 'js-cookie'

const CONFIG = {
  refreshInterval: 5 * 60,
  appName: process.env.RAILS_ENV,
}

const fetchConfig = () =>
  fetchAPI(APP_ISO_CONF.api_config_url, {
    useToken: false,
  })

// TODO: This function removes the old impletation of Unleash proxy data cache.
// Remove this function later when we think all active users local storage have
// been cleared. Also remove "unleash_proxy_cache_name" from APP_ISO_CONF
const removeLocalStorageCache = () => {
  const oldUnleashProxyCache = localStorage.getItem(
    APP_ISO_CONF.unleash_proxy_cache_name
  )

  if (oldUnleashProxyCache) {
    localStorage.removeItem(APP_ISO_CONF.unleash_proxy_cache_name)
  }
}

const getCachedUnleashProxyData = () => {
  removeLocalStorageCache()

  const unleashProxyUrlCache = Cookies.get(
    APP_ISO_CONF.unleash_proxy_url_cache_name
  )
  const unleashProxyKeyCache = Cookies.get(
    APP_ISO_CONF.unleash_proxy_key_cache_name
  )

  const unleashProxyCache = {
    url: unleashProxyUrlCache || '',
    clientKey: unleashProxyKeyCache || '',
  }

  return unleashProxyCache
}

const hasCachedUnleashProxyData = () => {
  const { url, clientKey } = getCachedUnleashProxyData()

  return Boolean(url && clientKey)
}

const setCachedUnleashProxyData = ({ url, clientKey }) => {
  Cookies.set(APP_ISO_CONF.unleash_proxy_url_cache_name, url)
  Cookies.set(APP_ISO_CONF.unleash_proxy_key_cache_name, clientKey)
}

const getCachedGrowthbookData = () => {
  const growthbookApiHostCache = Cookies.get(
    APP_ISO_CONF.growthbook_api_host_cache_name
  )
  const growthbookClientKeyCache = Cookies.get(
    APP_ISO_CONF.growthbook_client_key_cache_name
  )

  return {
    apiHost: growthbookApiHostCache || '',
    clientKey: growthbookClientKeyCache || '',
  }
}

const hasCachedGrowthbookData = () =>
  Cookies.get(APP_ISO_CONF.growthbook_api_host_cache_name) !== undefined &&
  Cookies.get(APP_ISO_CONF.growthbook_client_key_cache_name) !== undefined

const setCachedGrowthbookData = ({ apiHost, clientKey }) => {
  Cookies.set(APP_ISO_CONF.growthbook_api_host_cache_name, apiHost || '')
  Cookies.set(APP_ISO_CONF.growthbook_client_key_cache_name, clientKey || '')
}

const getFreshFeatureFlagsData = async () => fetchConfig()

export {
  CONFIG,
  getCachedUnleashProxyData,
  hasCachedUnleashProxyData,
  setCachedUnleashProxyData,
  getCachedGrowthbookData,
  hasCachedGrowthbookData,
  setCachedGrowthbookData,
  getFreshFeatureFlagsData,
}
